/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-06.
 * Reducer for the container.
 */
import { updateState, addPropertyInItem } from '../../common/helpers';
import { NOTIFY, FETCH_COMPLETE, FETCH_DATA, EDITING_ITEM } from './types';

const INITIAL_STATE = {
    formOpen: false,
    tabuladorState: {
      tabuladorFormOpen: false
    },
    customers: [],
    customsHouses: [],
    executiveUsers: [],
    isLoading: false,
    activePage: 0,
    numPages: 0,
    showNotification:false,
    showMessage: '',
    notificationColor: ''
};

export default (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        case NOTIFY:
            return updateState(payload, state);
        case FETCH_DATA:
            return { ...state, isLoading: true };
        case FETCH_COMPLETE:
            return { ...state, ...updateState(payload, state), isLoading: false };
        case EDITING_ITEM:
            return { ...state, ...addPropertyInItem(payload, state), isLoading: false };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./containers/clientes/reducer.js